export class FaqAPI {
  constructor(Client, Store) {
    this.Client = Client;
  }

  all = () => {
    return this.Client.get('/faq').then(response => {
      if (!response || !response.data) return false;
      return response.data;
    });
  };

  single = id => {
    return this.Client(`/faq/${id}`).then(response => {
      if (!response || !response.data) return false;
      return response.data;
    });
  };
}

export default FaqAPI;
